var _g, _g2, _path, _path2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 346,
    viewBox: "0 0 423 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1243_68155)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 38,
    width: 208,
    height: 231,
    rx: 8,
    fill: "url(#paint0_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 54,
    width: 176,
    height: 23,
    rx: 8,
    fill: "url(#paint1_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 155,
    width: 176,
    height: 23,
    rx: 8,
    fill: "url(#paint2_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 187,
    width: 176,
    height: 16,
    rx: 8,
    fill: "url(#paint3_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 230,
    width: 145,
    height: 23,
    rx: 11.5,
    fill: "url(#paint4_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 230,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint5_linear_1243_68155)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1243_68155)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 103,
    width: 208,
    height: 231,
    rx: 8,
    fill: "url(#paint6_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 119,
    width: 176,
    height: 23,
    rx: 8,
    fill: "url(#paint7_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 220,
    width: 176,
    height: 23,
    rx: 8,
    fill: "url(#paint8_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 252,
    width: 176,
    height: 16,
    rx: 8,
    fill: "url(#paint9_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 295,
    width: 145,
    height: 23,
    rx: 11.5,
    fill: "url(#paint10_linear_1243_68155)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 295,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint11_linear_1243_68155)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278 76.5C278 81.1944 274.194 85 269.5 85C264.806 85 261 81.1944 261 76.5C261 71.8056 264.806 68 269.5 68C274.194 68 278 71.8056 278 76.5ZM264.392 76.5C264.392 79.3212 266.679 81.6083 269.5 81.6083C272.321 81.6083 274.608 79.3212 274.608 76.5C274.608 73.6788 272.321 71.3917 269.5 71.3917C266.679 71.3917 264.392 73.6788 264.392 76.5Z",
    fill: "url(#paint12_linear_1243_68155)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 178.5C17 183.194 13.1944 187 8.5 187C3.80558 187 0 183.194 0 178.5C0 173.806 3.80558 170 8.5 170C13.1944 170 17 173.806 17 178.5ZM3.39171 178.5C3.39171 181.321 5.67877 183.608 8.5 183.608C11.3212 183.608 13.6083 181.321 13.6083 178.5C13.6083 175.679 11.3212 173.392 8.5 173.392C5.67877 173.392 3.39171 175.679 3.39171 178.5Z",
    fill: "url(#paint13_linear_1243_68155)",
    fillOpacity: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1243_68155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115 309.5C117.954 309.214 120.719 307.916 122.825 305.825C124.916 303.719 126.214 300.954 126.5 298C126.786 300.954 128.084 303.719 130.175 305.825C132.281 307.916 135.046 309.214 138 309.5C135.043 309.775 132.275 311.075 130.175 313.175C128.075 315.275 126.775 318.043 126.5 321C126.214 318.046 124.916 315.281 122.825 313.175C120.719 311.084 117.954 309.786 115 309.5Z",
    fill: "url(#paint14_linear_1243_68155)",
    fillOpacity: 0.7
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1243_68155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127 11.5C129.954 11.214 132.719 9.91576 134.825 7.82516C136.916 5.71854 138.214 2.95409 138.5 0C138.786 2.95409 140.084 5.71854 142.175 7.82516C144.281 9.91576 147.046 11.214 150 11.5C147.043 11.7749 144.275 13.0748 142.175 15.1748C140.075 17.2749 138.775 20.0429 138.5 23C138.214 20.0459 136.916 17.2815 134.825 15.1748C132.719 13.0842 129.954 11.786 127 11.5Z",
    fill: "url(#paint15_linear_1243_68155)",
    fillOpacity: 0.7
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1243_68155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 17.5C112.413 17.3632 113.735 16.7423 114.742 15.7425C115.742 14.735 116.363 13.4128 116.5 12C116.637 13.4128 117.258 14.735 118.258 15.7425C119.265 16.7423 120.587 17.3632 122 17.5C120.586 17.6315 119.262 18.2532 118.258 19.2575C117.253 20.2619 116.631 21.5857 116.5 23C116.363 21.5872 115.742 20.265 114.742 19.2575C113.735 18.2577 112.413 17.6368 111 17.5Z",
    fill: "url(#paint16_linear_1243_68155)",
    fillOpacity: 0.7
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1243_68155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 130.5C7.41283 130.363 8.73495 129.742 9.74247 128.742C10.7423 127.735 11.3632 126.413 11.5 125C11.6368 126.413 12.2577 127.735 13.2575 128.742C14.265 129.742 15.5872 130.363 17 130.5C15.5857 130.631 14.2619 131.253 13.2575 132.258C12.2532 133.262 11.6315 134.586 11.5 136C11.3632 134.587 10.7423 133.265 9.74247 132.258C8.73495 131.258 7.41283 130.637 6 130.5Z",
    fill: "url(#paint17_linear_1243_68155)",
    fillOpacity: 0.7
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1243_68155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 294.5C105.413 294.363 106.735 293.742 107.742 292.742C108.742 291.735 109.363 290.413 109.5 289C109.637 290.413 110.258 291.735 111.258 292.742C112.265 293.742 113.587 294.363 115 294.5C113.586 294.631 112.262 295.253 111.258 296.258C110.253 297.262 109.631 298.586 109.5 300C109.363 298.587 108.742 297.265 107.742 296.258C106.735 295.258 105.413 294.637 104 294.5Z",
    fill: "url(#paint18_linear_1243_68155)",
    fillOpacity: 0.7
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1243_68155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395 170.5C396.413 170.363 397.735 169.742 398.742 168.742C399.742 167.735 400.363 166.413 400.5 165C400.637 166.413 401.258 167.735 402.258 168.742C403.265 169.742 404.587 170.363 406 170.5C404.586 170.631 403.262 171.253 402.258 172.258C401.253 173.262 400.631 174.586 400.5 176C400.363 174.587 399.742 173.265 398.742 172.258C397.735 171.258 396.413 170.637 395 170.5Z",
    fill: "url(#paint19_linear_1243_68155)",
    fillOpacity: 0.7
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1243_68155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 153.5C402.954 153.214 405.719 151.916 407.825 149.825C409.916 147.719 411.214 144.954 411.5 142C411.786 144.954 413.084 147.719 415.175 149.825C417.281 151.916 420.046 153.214 423 153.5C420.043 153.775 417.275 155.075 415.175 157.175C413.075 159.275 411.775 162.043 411.5 165C411.214 162.046 409.916 159.281 407.825 157.175C405.719 155.084 402.954 153.786 400 153.5Z",
    fill: "url(#paint20_linear_1243_68155)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1243_68155",
    x: 26,
    y: 34,
    width: 224,
    height: 247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1243_68155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1243_68155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1243_68155",
    x: 165,
    y: 99,
    width: 224,
    height: 247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1243_68155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1243_68155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1243_68155",
    x1: 81.8214,
    y1: 64.6538,
    x2: 243.411,
    y2: 267.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1243_68155",
    x1: 59,
    y1: 71,
    x2: 241,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1243_68155",
    x1: 59,
    y1: 172,
    x2: 241,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1243_68155",
    x1: 59,
    y1: 198.826,
    x2: 241,
    y2: 198.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1243_68155",
    x1: 57.4148,
    y1: 247,
    x2: 207.358,
    y2: 247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1243_68155",
    x1: 204.176,
    y1: 247,
    x2: 227.96,
    y2: 247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1243_68155",
    x1: 220.821,
    y1: 129.654,
    x2: 382.411,
    y2: 332.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1243_68155",
    x1: 198,
    y1: 136,
    x2: 380,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1243_68155",
    x1: 198,
    y1: 237,
    x2: 380,
    y2: 237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1243_68155",
    x1: 198,
    y1: 263.826,
    x2: 380,
    y2: 263.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1243_68155",
    x1: 196.415,
    y1: 312,
    x2: 346.358,
    y2: 312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1243_68155",
    x1: 343.176,
    y1: 312,
    x2: 366.96,
    y2: 312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1243_68155",
    x1: 269.5,
    y1: 68,
    x2: 269.5,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1243_68155",
    x1: 8.5,
    y1: 170,
    x2: 8.5,
    y2: 187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1243_68155",
    x1: 126.5,
    y1: 298,
    x2: 126.5,
    y2: 321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1243_68155",
    x1: 138.5,
    y1: 0,
    x2: 138.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1243_68155",
    x1: 116.5,
    y1: 12,
    x2: 116.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1243_68155",
    x1: 11.5,
    y1: 125,
    x2: 11.5,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1243_68155",
    x1: 109.5,
    y1: 289,
    x2: 109.5,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1243_68155",
    x1: 400.5,
    y1: 165,
    x2: 400.5,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1243_68155",
    x1: 411.5,
    y1: 142,
    x2: 411.5,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1243_68155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(115 298)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1243_68155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(127)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1243_68155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(111 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1243_68155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(6 125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1243_68155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(104 289)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1243_68155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(395 165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1243_68155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(400 142)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitial);
export default __webpack_public_path__ + "static/media/initial.886813efd2202211148d2d23f8409cb3.svg";
export { ForwardRef as ReactComponent };